const STORAGE_KEY = 'lookout-return-after-sign-out';

/** Only a path on this site. The server checks every return path again. */
function isLocalPath(path: string): boolean {
  return path.startsWith('/') && !path.startsWith('//') && !path.startsWith('/\\');
}

/**
 * A Google or SSO sign-out goes through the provider's sign-out page, which always returns to /login. The page
 * that asked for the sign-out saves its target here, and the login page reads it on its next visit.
 */
export function rememberReturnAfterSignOut(path: string): void {
  if (typeof window === 'undefined' || !isLocalPath(path)) return;
  try {
    window.sessionStorage.setItem(STORAGE_KEY, path);
  } catch {
    // Storage is off (private mode): the user lands on /login without the target.
  }
}

/** The saved target, or null. Reading does not remove it, so a repeated render reads the same value. */
export function readReturnAfterSignOut(): string | null {
  if (typeof window === 'undefined') return null;
  try {
    const path = window.sessionStorage.getItem(STORAGE_KEY);
    return path && isLocalPath(path) ? path : null;
  } catch {
    return null;
  }
}

export function clearReturnAfterSignOut(): void {
  if (typeof window === 'undefined') return;
  try {
    window.sessionStorage.removeItem(STORAGE_KEY);
  } catch {
    // Ignore storage access failures.
  }
}
